import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';

import { WebApiModel } from '../models/web-api.model';

export class RxType<T> {
  _rxSubject: Subject<T>;
  _rxObservable: Observable<T>;

  constructor() {
    this._rxSubject = new Subject<T>();
    this._rxObservable = this._rxSubject.asObservable();
  }

  rxNext(value: T): void {
    this._rxSubject.next(value);
  }

  rxSubscribe(callback: (n: T) => any): Subscription {
    return this._rxObservable.subscribe(callback);
  }
}

@Injectable()
export class StateRxService {
  public escPressed = new RxType<number>();
  public arrowUpPressed = new RxType<number>();
  public arrowDownPressed = new RxType<number>();
  public enterPressed = new RxType<number>();
  public isLoading = new RxType<boolean>();
  public hasError = new RxType<boolean>();
  public mobileLayoutChanged = new RxType<boolean>();
  public closePopup = new RxType<boolean>();
  public findClick = new RxType<any>();
  public toggleMapSidebar = new RxType<WebApiModel.Location>();
  public openPopupMap = new RxType<WebApiModel.Location[]>();
  public searchQueryParameters = new RxType<any>();
  public customMessage = new RxType<any>();
}
